import { Title } from '@interhyp/platform-icons';
import { DropdownOption, Typography } from '@platform/elements';
import React, { useMemo } from 'react';
import { DropdownToolbarItem } from "./DropdownToolbarItem.js";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function HeadingToolbarItem({
  active,
  headings = [1, 2, 3, 4, 5],
  action,
  disabled,
  title = 'Absatzstil'
}) {
  // For some reason this array creation has to be in another position than inline because it otherwise breaks the children-parsing-thing
  const options = useMemo(() => {
    return [...headings.map(heading => /*#__PURE__*/_jsx(DropdownOption, {
      label: heading.toString(),
      onClick: () => action?.(heading),
      children: /*#__PURE__*/_jsxs(Typography, {
        variant: `h${heading}`,
        margin: false,
        children: ["\xDCberschrift ", heading]
      })
    }, heading)), /*#__PURE__*/_jsx(DropdownOption, {
      label: "Absatz",
      onClick: () => action?.(undefined),
      children: /*#__PURE__*/_jsx(Typography, {
        margin: false,
        children: "Absatz"
      })
    }, "paragraph")];
  }, [action, headings]);
  return /*#__PURE__*/_jsx(DropdownToolbarItem, {
    activeItem: active?.toString(),
    on: active !== undefined,
    disabled: disabled,
    useChildAsButton: true,
    options: /*#__PURE__*/_jsx(_Fragment, {
      children: options
    }),
    icon: Title,
    title: title
  });
}